module.exports = __webpack_public_path__ + "static/media/home_intro_rose.439ce35b.png";